import React from 'react';
import { useJijelStore } from '../../../../store/main/modal/usejijelStore';
import { ChevronLeft } from 'lucide-react';
import MobileJijelImageModal from './MobileJijelImageModal';

const CONTACT_INFO = [
  {
    icon: '/imgs/mainSwiper/mailcon.svg',
    text: 'info@fks.co.kr',
  },
  {
    icon: '/imgs/mainSwiper/call.svg',
    text: '1666-9295',
  },
  {
    icon: '/imgs/mainSwiper/clock.svg',
    text: '월~금 10:00 - 18:00',
  },
] as const;

const JijelModal = () => {
  const { isMobileOpen, setIsMobileOpen, setIsMobileImageOpen } =
    useJijelStore();

  if (!isMobileOpen) return null;

  return (
    <div className='fixed inset-0 z-50 flex flex-col bg-white'>
      <header className='flex items-center px-5 py-4 border-b border-gray-100'>
        <button
          onClick={() => setIsMobileOpen(false)}
          className='flex items-center justify-center'
        >
          <ChevronLeft className='w-6 h-6' />
        </button>
        <h1 className='flex-1 text-center text-lg font-medium'>
          지젤 라이프그라피 서초
        </h1>
      </header>

      <div className='flex-1 overflow-y-auto'>
        <div className='px-5 py-8'>
          <div className='space-y-1'>
            <h2 className='text-xl font-medium'>분양 영업 경험이 없어도,</h2>
            <h2 className='text-xl font-medium'>
              주변 추천만으로도 추가 수익 기회!
            </h2>
            <p className='mt-4 text-base text-gray-700'>
              관심 있으신 분은 하단 연락처로 문의 바랍니다.
            </p>
          </div>

          <div className='mt-8 space-y-3'>
            {CONTACT_INFO.map((info, index) => (
              <div
                key={index}
                className='flex items-center gap-3 px-4 py-4 bg-gray-50 rounded-xl'
              >
                <img src={info.icon} alt='' className='w-6 h-6' />
                <span className='text-base'>{info.text}</span>
              </div>
            ))}
          </div>

          <button
            onClick={() => setIsMobileImageOpen(true)}
            className='w-full mt-8'
          >
            <img
              src='/imgs/mainSwiper/jijel_seocho.png'
              alt='지젤 라이프그라피 서초 견적서'
              className='w-full rounded-xl'
            />
          </button>
        </div>
      </div>

      <MobileJijelImageModal />
    </div>
  );
};

export default JijelModal;
